(function () {
  'use strict';

  var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

  var getText = function (editor) {
    var $doc = $(editor.getContent({withoutCursorMarker: true}));
    $doc.find('img').each(function (index) {
      var text = $(this).attr('src') === '' ? '![image' + index + ']' : $(this).attr('src');
      $(this).replaceWith($('<span>').text(text));
    });

    return $doc.text().trim();
  };

  function Plugin () {
    global.add('content', function (editor) {
      return {
        getText: () => getText(editor),
      };
    });
  }

  Plugin();
}());
